import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  addMedia({ commit }, item) {
    return this.$axios.$post('admin/media/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
    })
  },
  removeMedia({ commit }, item) {
    return this.$axios.$delete(`admin/media/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateMedia({ commit }, item) {
    return this.$axios.$put(`admin/media/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
    })
  },
  fetchMedia({ commit }) {
    this.$axios.$get('admin/media').then((response) => {
      commit('load', response.data)
    })
  },
}
